module.exports = __webpack_public_path__ + "img/berechnung_2.baacaaa9.png";